export default [

    {
        title: 'Fabrics', link: '/fabric', icon: 'file-text', sub: [
            { title: 'Dashboard', link: '/fabric/dashboard' },
            { title: 'Inventory', link: '/fabric/listing/inventory' },
            { title: 'Assets', link: '/fabric/assets' },
            { title: 'Analytics', link: '/fabric/analytics' },
            { title: 'Fabrics', link: '/fabric/listing/list_view' },
            { title: 'Orders', link: '/fabric/orders' },
            { title: 'Deliveries', link: '/fabric/deliveries' },
            { title: 'Withdraw', link: '/fabric/roll/withdraw' },
            { title: 'Suppliers', link: '/fabric/suppliers' },
            { title: 'Roll Logs', link: '/fabric/roll/log' },
            { title: 'Status Logs', link: '/fabric/status/log' },
            { title: 'Composition Label', link: '/fabric/composition' },
            { title: 'Thread Color', link: '/fabric/thread_colors' },
            { title: 'Interlinings', link: '/fabric/interlinings' },
            { title: 'Emb Thread Color', link: '/fabric/thread_colors/embroidery' },
            { title: 'Button Color', link: '/fabric/button_colors' },
            { title: 'Fabric Family', link: '/fabric/fabric_families' },
            { title: 'Availability Override', link: '/fabric/availability_override' },
            { title: 'Image Review', link: '/fabric/images_review' },
            { title: 'Overview', link: '/fabric/overview' }
        ]
    },

    {
        title: 'Books', link: '/book', icon: 'book', sub: [
            { title: 'Main Fabric Books', link: '/book/list/main-fabric-books' },
            { title: 'Befeni Designed Books', link: '/book/list/befeni-designed-books' },
            { title: 'Consultant Curated Books', link: '/book/curated' },
        ]
    },

    { title: 'Shirt Dashboard', link: '/shirt/dashboard', icon: 'tachometer' },

    { title: 'All', link: '/shirt/listings/all_shirt', icon: 'list', badge: null, keyword: 'all_shirts' },

    { title: 'Daily breakdown', link: '/shirt/listings/daily_breakdown', icon: 'list', badge: null },

    {
        title: 'New Orders', link: [
            '/shirt/listings/new_order',
            '/shirt/listings/collector_printed',
            '/shirt/listings/documents_printed'
        ], icon: 'file-o', badge: null, keyword: 'new_orders', sub: [
            { title: 'New Orders', badge: null, keyword: 'new_orders', link: '/shirt/listings/new_order' },
            { title: 'Collector Printed', badge: null, keyword: 'collector_printed', link: '/shirt/listings/collector_printed' },
            { title: 'Document Printed', badge: null, keyword: 'document_printed', link: '/shirt/listings/documents_printed' },
        ]
    },

    {
        title: 'Cutting', link: [
            '/shirt/listings/cutting_preparation',
            '/shirt/listings/c_and_c_cutting',
            '/shirt/listings/cutting',
            '/shirt/listings/fusing_and_embroidery'
        ], icon: 'scissors', badge: null, keyword: 'cutting', sub: [
            { title: 'Cutting Prep.', badge: null, keyword: 'cutting_and_preparation', link: '/shirt/listings/cutting_preparation' },
            { title: 'C and C Cutting', badge: null, keyword: 'c_and_c_cutting', link: '/shirt/listings/c_and_c_cutting' },
            { title: 'Cutting', badge: null, keyword: 'cutting', link: '/shirt/listings/cutting' },
            { title: 'Fusing and Emb', badge: null, keyword: 'fusing_and_embroidery', link: '/shirt/listings/fusing_and_embroidery' },
        ]
    },

    {
        title: 'Stitching', link: [
            '/shirt/listings/stitching_1',
            '/shirt/listings/stitching_2',
            '/shirt/listings/buttons',
        ], icon: 'stumbleupon', badge: null, keyword: 'stitching', sub: [
            { title: 'Stitching 1', badge: null, keyword: 'stitching_1', link: '/shirt/listings/stitching_1' },
            { title: 'Stitching 2', badge: null, keyword: 'stitching_2', link: '/shirt/listings/stitching_2' },
            { title: 'Buttons', badge: null, keyword: 'buttons', link: '/shirt/listings/buttons' },
        ]
    },

    {
        title: 'Finishing', link: [
            '/shirt/listings/qc',
            '/shirt/listings/packaging'
        ], icon: 'flag-checkered', badge: null, keyword: 'finishing', sub: [
            { title: 'QC', badge: null, keyword: 'qc', link: '/shirt/listings/qc' },
            { title: 'Packaging', badge: null, keyword: 'packaging', link: '/shirt/listings/packaging' },
        ]
    },

    {
        title: 'Shelf', link: [
            '/shelf',
            '/shelf/box_management',
            '/shirt/shipment'
        ], icon: 'archive', badge: null, keyword: 'shelf', sub: [
            { title: 'Show Shelf', link: '/shelf' },
            { title: 'Box Management', link: '/shelf/box_management' },
            { title: 'Shipment', link: '/shirt/shipment' },
        ]
    },

    {title: 'Waiting', badge: null, keyword: 'waiting', link: '/shirt/listings/waiting', icon: 'star-o', sub: [
        {title: 'All', badge: null, keyword: 'all', link: '/shirt/listings/waiting/all'},
        {title: 'Support: Fabric n/a', badge: null, keyword: 'support_fabric_na', link: '/shirt/listings/waiting/support_fabric_na'},
        {title: 'Support: Other', badge: null, keyword: 'support_other', link: '/shirt/listings/waiting/support_other'},
        {title: 'Pattern', badge: null, keyword: 'pattern', link: '/shirt/listings/waiting/pattern'},
        {title: 'Fabric', badge: null, keyword: 'fabric', link: '/shirt/listings/waiting/fabric'},
        {title: 'Other', badge: null, keyword: 'other', link: '/shirt/listings/waiting/other'},
        {title: 'Hold', badge: null, keyword: 'hold', link: '/shirt/listings/waiting/hold'},
        {title: 'Special Request', badge: null, keyword: 'special_request', link: '/shirt/listings/waiting/special_request'},
        {title: 'Waiting Prepayment', badge: null, keyword: 'waiting_prepayment', link: '/shirt/listings/waiting/waiting_prepayment'},
        {title: 'Don\'t Touch', badge: null, keyword: 'dont_touch', link: '/shirt/listings/waiting/dont_touch'},
        {title: 'S&N', badge: null, keyword: 's&n', link: '/shirt/listings/waiting/s&n'},
    ]},

    {
        title: 'Urgent', badge: null, keyword: 'urgent', link: '/shirt/listings/urgent', icon: 'star-o', sub: [
            { title: 'Fast track', badge: null, keyword: 'fast_track', link: '/shirt/listings/urgent/fast_track' },
            { title: 'Repair', badge: null, keyword: 'repair', link: '/shirt/listings/urgent/repair' },
            { title: 'Remake', badge: null, keyword: 'remake', link: '/shirt/listings/urgent/remake' },
            { title: 'Return', badge: null, keyword: 'return', link: '/shirt/listings/urgent/return' },
            { title: 'Prod.-time', badge: null, keyword: 'prod_time', link: '/shirt/listings/urgent/prod_time' },
            { title: 'Support/Special', badge: null, keyword: 'support_special', link: '/shirt/listings/urgent/support_special' }
        ]
    },

    { title: 'Repair', badge: null, keyword: 'repair', link: '/shirt/repair/overview', icon: 'star-o' },

    { title: 'Time', badge: null, keyword: 'time', link: '/shirt/time', icon: 'star-o' },

    { title: 'Accessories Order', link: '/accessories/order', icon: 'outdent', keyword: 'accessories_orders', badge: null },

    { title: 'Gallery', link: '/shirt/gallery', icon: 'star-o' },

    { title: 'Emails', link: '/emails', icon: 'envelope' },

    {
        title: 'Settings', link: '/settings', icon: 'gear', sub: [
            { title: 'Process Gallery Images', link: '/settings/gallery_images_processor' },
            { title: 'Bulk Pattern Upload', link: '/settings/bulk_pattern_upload' },
        ]
    },
    {
        title: 'Product Orders', link: '/product_order', icon: 'archive', keyword: 'product_order', sub: [
            {
                title: 'Overview', link: '/product_order/overview', badge: null, keyword: "product_order_overview", sub: [
                    { title: 'All', link: '/product_order/overview/all', badge: null, keyword: "product_order_overview_all" },
                    { title: 'New', link: '/product_order/overview/imported', badge: null, keyword: "product_order_overview_imported" },
                    { title: 'Started', link: '/product_order/overview/started', badge: null, keyword: "product_order_overview_started" },
                    { title: 'Cutting', link: '/product_order/overview/cutting', badge: null, keyword: "product_order_overview_cutting" },
                    { title: 'Stitching', link: '/product_order/overview/stitching', badge: null, keyword: "product_order_overview_stitching" },
                    { title: 'QC', link: '/product_order/overview/qc', badge: null, keyword: "product_order_overview_qc" },
                    { title: 'Packaging', link: '/product_order/overview/packaging', badge: null, keyword: "product_order_overview_packaging" }
                ],
            },
            { title: 'Individual Order Items', link: '/product_order/items' },
            { title: 'Scan', link: '/product_order/scan' },
            { title: 'Certificate', link: '/product_order/certificate' }
        ]
    },
    {
        title: 'Scans', link: '/shirt/scan', icon: 'barcode', sub: [
            { title: 'Fabric Scan', link: '/shirt/scan/fabric/shirt_order' },
            { title: 'Shelf Scan', link: '/shirt/scan/shelf' },
            { title: 'Create Certificate', link: '/shirt/scan/certificate' },
        ]
    },

    {
        title: 'Performance', link: '/performance_scanning', icon: 'bullseye', sub: [
            { title: 'Scan', link: '/performance_scanning/scan' },
            { title: 'Download', link: '/performance_scanning/download' },
            { title: 'Manage Employees', link: '/performance_scanning/employees/list' },
        ]
    },

]
